// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3pTbV","large":"styles_large__2Iq0T"};